// Raised by password.js when a click reveals the password, so password-widget.js can track it
// without depending on which click listener the browser runs first.
export const REVEALED = "mf:password-revealed"
